/**
 * DTMF (Dual-Tone Multi-Frequency) constants for letter-to-number mapping
 * Used for IVR systems that require alphabetic input
 */

// Dialpad button configuration
export const DIALPAD_BUTTONS = [
  { digit: '1', label: '' },
  { digit: '2', label: 'ABC' },
  { digit: '3', label: 'DEF' },
  { digit: '4', label: 'GHI' },
  { digit: '5', label: 'JKL' },
  { digit: '6', label: 'MNO' },
  { digit: '7', label: 'PQRS' },
  { digit: '8', label: 'TUV' },
  { digit: '9', label: 'WXYZ' },
  { digit: '*', label: '' },
  { digit: '0', label: '+' },
  { digit: '#', label: '' },
];

// Letter-to-DTMF mapping based on phone keypad layout
export const LETTER_TO_DTMF_MAP: Record<string, string> = {
  // Key 2: ABC
  A: '*21',
  B: '*22',
  C: '*23',
  a: '*21',
  b: '*22',
  c: '*23',

  // Key 3: DEF
  D: '*31',
  E: '*32',
  F: '*33',
  d: '*31',
  e: '*32',
  f: '*33',

  // Key 4: GHI
  G: '*41',
  H: '*42',
  I: '*43',
  g: '*41',
  h: '*42',
  i: '*43',

  // Key 5: JKL
  J: '*51',
  K: '*52',
  L: '*53',
  j: '*51',
  k: '*52',
  l: '*53',

  // Key 6: MNO
  M: '*61',
  N: '*62',
  O: '*63',
  m: '*61',
  n: '*62',
  o: '*63',

  // Key 7: PQRS
  P: '*71',
  Q: '*72',
  R: '*73',
  S: '*74',
  p: '*71',
  q: '*72',
  r: '*73',
  s: '*74',

  // Key 8: TUV
  T: '*81',
  U: '*82',
  V: '*83',
  t: '*81',
  u: '*82',
  v: '*83',

  // Key 9: WXYZ
  W: '*91',
  X: '*92',
  Y: '*93',
  Z: '*94',
  w: '*91',
  x: '*92',
  y: '*93',
  z: '*94',
};
